import { render } from "./RootChrome.vue?vue&type=template&id=20529c9a"
import script from "./RootChrome.vue?vue&type=script&lang=js"
export * from "./RootChrome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__